<template>
  <div class="wrapBox" style=" padding-left:4px;padding-right:4px;padding-top:8px;">
    <div id="myMainGoodTrade" :style="{width: '100%', height: '250px'}"> 
       
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      titleText: '2018年重点贸易商品进出口分析',
      textStyle: {color:'#ccc', fontStyle:'normal', fontWeight:'bold', fontFamily:'sans-serif', fontSize:12 },
      legendPadding: [65, 5, 15, 5]

    }
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myMainGoodTrade = this.$echarts.init(document.getElementById('myMainGoodTrade'), 'dark')
        myMainGoodTrade.setOption({
    title: {
        text: this.titleText,
        textStyle: this.textStyle
    },
    tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b} : {c}%"
    },
    calculable: true,
    series: [
        {
            name: '漏斗图',
            type: 'funnel',
            width: '25%',
            height: '80%',
            left: '5%',
            top: '10%',
            data:[
                {value: 167, name:'越野车'},
                {value: 56, name:'精炼铜阴极'},
                {value: 50, name:'小轿车'},
                {value: 25, name:'机动车辆用电气照明装置'},
                {value: 22, name:'电力分配盘板台'},
                {value: 21, name:'越野车小排量'},
                {value: 21, name:'车用零件/附件'},
                {value: 19, name:'自动调节或控制仪器及装置'},
                {value: 19, name:'品目8701至8704零/附件'},
                {value: 18, name:'具有变流功能的半导体模块'}
            ]
        },
        {
            name: '金字塔',
            type:'funnel',
            width: '25%',
            height: '80%',
            left: '70%',
            top: '10%',
            sort: 'ascending',
            label: {
                normal: {
                    position: 'left'
                }
            },
            data:[
                {value: 155, name:'无线电话机'},
                {value: 133, name:'液晶显示板'},
                {value: 119, name:'品目8471零件/附件'},
                {value: 57, name:'品目8517零件/附件'},
                {value: 44, name:'便携式自动数据处理设备'},
                {value: 40, name:'其他彩色液晶监视器'},
                {value: 27, name:'电力分配盘板台'},
                {value: 26, name:'平板电脑'},
                {value: 23, name:'彩色电视接收机零件'},
                {value: 22, name:'塑料制鞋面的鞋靴'}
            ]
        }
    ]
});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MainGoodTrade.vue